import api from "../../../utils/api";

export const getStudentLife = async () => {
  return (await api.get("/StudentLife/studentlife/GetAllStudentLife"))
    ?.data as StudentLifeResponse;
};

export const getOverviewByStudentLifeId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetOverviewByStudentLifeId?Id=${id}`
    )
  )?.data as OverViewResponse;
};

export const getSchoolSummaryByStudentLifeId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetSchoolsummaryByStudentLifeId?Id=${id}`
    )
  )?.data as SchoolSummaryResponse;
};

export const getCampusExperienceByStudentLifeId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetCampusExperienceByStudentLifeId?Id=${id}`
    )
  )?.data as CampusExperienceResponse;
};

export const getCampusExperienceItemByCampusExperienceId = async (
  id: number
) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetCampusExperienceItemByCampusExperienceId?Id=${id}`
    )
  )?.data as CampusExperienceItemResponse;
};

export const getSupportGuidanceByStudentLifeId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetSupportGuidanceByStudentLifeId?Id=${id}`
    )
  )?.data as SupportGuidanceResponse;
};

export const getFitnessAthleticsByStudentLifeId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetFitnessAthleticsByStudentLifeId?Id=${id}`
    )
  )?.data as FitnessAthleticsResponse;
};

export const getFitnessAthleticsItemByFitnessId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetFitnessAthleticsItemByFitnessId?Id=${id}`
    )
  )?.data as FitnessAthleticsItemResponse;
};

export const getFitnessAthleticsImageByFitnessId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetFitnessImageByFitnessAthleticsId?Id=${id}`
    )
  )?.data as FitnessAthleticsImageResponse;
};

export const getSupportItemBySupportGuidanceId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetSupportItemBySupportGuidanceId?Id=${id}`
    )
  )?.data as SupportGuidanceItemResponse;
};

export const getStudentActivityByStudentLifeId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetStudentActivityByStudentLifeId?Id=${id}`
    )
  )?.data as StudentActivityResponse;
};

export const getStudentActivityItemByStudentActivityId = async (id: number) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetStudentActivityItemByStudentActivityId?Id=${id}`
    )
  )?.data as StudentActivityItemResponse;
};

export const getCampusExperienceImageByCampusExperienceId = async (
  id: number
) => {
  return (
    await api.get(
      `/StudentLife/studentlife/GetCampusExperienceImageByCampusExperienceId?Id=${id}`
    )
  )?.data as CampusExperienceImageResponse;
};

export const getNewsAndEvents = async () => {
  return (await api.get(`/HomePage/HomePage/GetAllNewEvent`))
    ?.data as NewsAndEventResponse;
};